import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { type AnalyticsParams, statsApi } from '~/entities/stats/api/stats'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'

export function useListingAnalytics(
  businessId: string,
  listingId: string,
  params: AnalyticsParams,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKey(
      QueryKey.ANALYTICS,
      'listing',
      listingId,
      params.granularity,
      params.from,
      params.to,
    ),
    queryFn: () => statsApi.getListingAnalytics(businessId, listingId, params),
    staleTime: 5 * MINUTES,
    placeholderData: keepPreviousData,
    enabled: !!businessId && !!listingId && options?.enabled !== false,
  })
}
